import { defaultsConfig } from "~config/sport/defaults";
import { PeriodTypes } from "~enums/periodTypes.ts";
import type { SportConfiguration } from "~types/sportConfiguration.ts";
import { footballUiConfig } from "./footballUi";

export const footballConfig: SportConfiguration = {
  ...defaultsConfig,
  uiConfiguration: footballUiConfig,
  periods: {
    [PeriodTypes.Period1]: { intlKey: "period.period1" },
    [PeriodTypes.Period2]: { intlKey: "period.period2" },
    [PeriodTypes.Period3]: { intlKey: "period.period3" },
    [PeriodTypes.Period4]: { intlKey: "period.period4" },
    [PeriodTypes.ExtraPeriod0]: { intlKey: "period.extraTime1" },
    [PeriodTypes.ExtraPeriod1]: { intlKey: "period.extraTime2" },
    [PeriodTypes.ExtraPeriod2]: { intlKey: "period.extraTime3" },
    [PeriodTypes.ExtraPeriod3]: { intlKey: "period.extraTime4" },
    [PeriodTypes.ExtraPeriod4]: { intlKey: "period.extraTime5" },
    [PeriodTypes.ExtraPeriod5]: { intlKey: "period.extraTime6" },
    [PeriodTypes.ExtraPeriod10]: { intlKey: "period.penaltyShootout" },
  },
};
